import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class ExtensionService extends ServiceCRUD {
  constructor() {
    super('/api/ramais');
  }
}

export default new ExtensionService();
